import * as React from 'react';
import styles from './index.less';
import CollectionCards from './CollectionCards';
import CollectionList from './CollectionList';

interface FCollectionItems2Props {
  resources: {
    itemID: string;
    itemTitle: string;
    itemSerial: number;
    itemNumber: string;
    resourceInfo: {
      id: string;
      cover: string;
      name: string;
      title: string;
      version: string;
      policy: string[];
      type: string[];
      status: 0 | 1 | 2 | 4;
      authProblem: boolean;
      updateDate: string;
      username: string;
      useAvatar: string;
      isChoice: boolean;
      intro: string;
      releaseDateTime?: string;
    };
  }[];

  showView: 'card' | 'list';

  showCheckbox?: 'show' | 'hide';
  checkedItemIDs?: string[];
  showTitle: 'title' | 'serial' | 'custom' | 'customNotEdited' | 'hide';
  showNumber: 'show' | 'hide';
  showCover: 'show' | 'hide';
  showIntroduction: 'show' | 'hide';

  draggable?: boolean;
  size?: 'normal' | 'small';

  onChangeChecked?(itemID: string, checked: boolean): void;

  onChangeCustomTitle?(itemID: string, title: string): void;

  onClickDelete?(itemID: string): void;

  onClick?(itemID: string, resourceID: string): void;

  onChangeIndex?(itemID: string, index: number, newList: FCollectionItems2Props['resources']): void;
}

function FCollectionItems2({
  resources,
  size = 'normal',
  onChangeCustomTitle,
  onClickDelete,
  onClick,
  showView,
  showCheckbox = 'hide',
  checkedItemIDs = [],
  onChangeChecked,
  showCover,
  showTitle,
  showNumber,
  showIntroduction,
  onChangeIndex,
  draggable,
}: FCollectionItems2Props) {
  if (showView === 'card') {
    return (
      <CollectionCards
        resources={resources}
        onChangeCustomTitle={onChangeCustomTitle}
        onClickDelete={onClickDelete}
        onClick={onClick}
        size={size}
        showCheckbox={showCheckbox}
        checkedItemIDs={checkedItemIDs}
        onChangeChecked={onChangeChecked}
        showCover={showCover}
        showTitle={showTitle}
        showNumber={showNumber}
        showIntroduction={showIntroduction}
        onChangeIndex={onChangeIndex}
        draggable={draggable}
      />
    );
  }

  // return null;
  return (
    <CollectionList
      resources={resources}
      onChangeCustomTitle={onChangeCustomTitle}
      onClickDelete={onClickDelete}
      onClick={onClick}
      showCheckbox={showCheckbox}
      checkedItemIDs={checkedItemIDs}
      onChangeChecked={onChangeChecked}
      showCover={showCover}
      showTitle={showTitle}
      showNumber={showNumber}
      showIntroduction={showIntroduction}
      onChangeIndex={onChangeIndex}
      draggable={draggable}
    />
  );
}

export default FCollectionItems2;
